import { z } from 'zod';

import {
  VenueDefaultDataAccommodation,
  VenueDefaultDataEquipment,
  VenueDefaultDataMobility,
} from '@/domain/project-venue/entities/project-venue.entity.ts';

export const venuePresetsDtoSchema = z.object({
  id: z.number().optional(),
  organisationId: z.number().or(z.string()),
  title: z.string().optional(),
  order: z.number().optional(),
  projectId: z.number().or(z.string()),
  values: z
    .object({
      avgCapacity: z.number().optional(),
      accommodation: z.custom<VenueDefaultDataAccommodation>().optional(),
      equipment: z.custom<VenueDefaultDataEquipment>().optional(),
      mobility: z.custom<VenueDefaultDataMobility>().optional(),
    })
    .optional(),
});

export const getVenuePresetsDtoSchema = z.object({
  data: z.array(venuePresetsDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export type VenuePresetDto = z.infer<typeof venuePresetsDtoSchema>;
